import React, { Component } from 'react'
import { connect } from 'react-redux'
import profileSelector from '../../selectors/profileSelector'
import balanceSelector from '../../selectors/balanceSelector'
import authSelector from '../../selectors/authSelector'
import { isEmptyObject } from '../../helpers/utility'
import { FETCH_USER_PROFILE, FETCH_USER_BALANCE_REQUEST } from '../../actions/actions'

import StudentProfileDigest from '../student/StudentProfileDigest'
import TeacherProfileDigest from '../teacher/TeacherProfileDigest'
import SchoolProfileDigest from '../school/SchoolProfileDigest'
import ManagerProfileDigest from '../manager/ManagerProfileDigest'
import SupervisorProfileDigest from '../supervisor/SupervisorProfileDigest'

import Dropdown from '../common/Dropdown/Dropdown'
import {Link} from 'react-router'
import LogoutLink from "../common/LogoutLink"

const profileContainers = {
  STUDENT: StudentProfileDigest,
  TEACHER: TeacherProfileDigest,
  SCHOOL: SchoolProfileDigest,
  MANAGER: ManagerProfileDigest,
  SUPERVISOR: SupervisorProfileDigest,
}

const dropdownItemsToRender = [
  <Link to='/dashboard/credit'>اعتبار</Link>,
  <Link to='/dashboard/orders'>سفارش‌ها</Link>,
  <LogoutLink />,
]

class ProfileDigestContainer extends Component {
  componentDidMount() {
    if (!isEmptyObject(this.props.userProfile.userProfile)) return

    const { dispatch, userType, userId } = this.props
    dispatch({ type: FETCH_USER_PROFILE, userId, userType })
    dispatch({ type: FETCH_USER_BALANCE_REQUEST })
  }

  shouldDisplayDropdownMenu = () =>
    this.props.userType !== 'MANAGER' && this.props.userType !== 'SUPERVISOR'

  render() {
    const Component = profileContainers[this.props.userType]
    if (!Component) return null

    return (
      <div id="profile-container">
        <Component {...this.props.userProfile} {...this.props.userBalance} />

        { this.shouldDisplayDropdownMenu() && <Dropdown items={dropdownItemsToRender} />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    userProfile: profileSelector(state),
    userBalance: balanceSelector(state),
    ...authSelector(state),
  }
}

export default connect(mapStateToProps)(ProfileDigestContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/ProfileDigestContainer.js